<template lang="html">
  <div class="contracts">
    <h2 class="text-center">Kategóriák (szerződések)</h2>
    <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6" class="pb-0" v-if="contracts != null && contracts != ''">
        <v-select
          v-model="contract_id"
          :items="contracts"
          item-text="contract_name"
          item-value="contract_id"
          label="Szerződés választása"
          solo
        >
          <template v-slot:selection="data">
            <div>
            <!-- HTML that describe how select should render selected items -->
            {{ data.item.contract_name }} - {{ data.item.contract_date }}
            </div>
          </template>
          <template v-slot:item="data">
            <div>
            <!-- HTML that describe how select should render items when the select is open -->
            {{ data.item.contract_name }} - {{ data.item.contract_date }} ({{data.item.contract_type}})
            </div>
          </template>
        </v-select>
        </v-col>
        </v-row>

        <v-row>
        <v-col class="text-center" cols="12">
        <p v-if="!studDetailsVaild || !customer_name">Szerződés létrehozásához minden kötelező személyes adatot ki kell tölteni!</p>
        <v-btn
          v-if="!studDetailsVaild || !customer_name"
          rounded
          color="primary"
          to="/adatok"
        >
        Személyes adatok
        </v-btn>
        <v-btn
          rounded
          @click="createContract"
          color="primary"
          v-if="customer_id && studDetailsVaild && customer_name"
          class="mb-4"
          :disabled="preloader"
        >
        Szerződés hozzáadása
        <v-icon dark>mdi-plus</v-icon>
        </v-btn>
        </v-col>
      </v-row>

        <v-card v-if="contract_id">
          <v-card-title>Szerződés adatai</v-card-title>
          <v-container>
          <v-row>
            <v-col cols="12" md="4">
              <v-select
                v-model="contract_type"
                :items="contract_type_options"
                label="Szerződés típusa"
                outlined
                readonly
                disabled
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="course_type"
                :items="course_type_options"
                label="Képzés típusa"
                outlined
                readonly
                disabled
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" class="mb-8" v-if="course_type == 2">
            <v-btn
              color="primary"
              @click="elearning_dialog = true"
              rounded
              outlined
            >
            E-learning információk
            <v-icon right>info</v-icon>
            </v-btn>
            </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="8">
                <v-select
                  v-model="gki_category_contract"
                  :items="gki_category_list_contract"
                  item-text="nev"
                  item-value="pallasz_id"
                  label="GKI alkategória"
                  outlined
                  :loading="loading"
                  v-if="contract_type == 4"
                  disabled
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="contract_date"
                  label="Szerződéskötés ideje"
                  outlined
                  readonly
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="selected_iroda"
                  :items="irodak"
                  item-value="training_place_id"
                  item-text="address"
                  label="Személyes ügyintézés helye"
                  outlined
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
          </v-row>
          <v-row v-if="contract_id">
            <v-col cols="12" md="2">
            <v-btn
              color="primary"
              rounded
              @click="update_contract_dialog = true"
            >
            Módosít
            <v-icon right dark>save</v-icon>
            </v-btn>
            </v-col>
            <v-col cols="12" md="2">
            <v-btn
              color="red"
              @click="archvie_contract_dialog = true"
              rounded
              outlined
            >
            Töröl
            <v-icon right dark>delete</v-icon>
            </v-btn>
            </v-col>
          </v-row>
          <br>
          </v-container>
        </v-card>

        <v-row v-if="contract_id">
          <v-col class="text-center mt-2 mb-2" cols="12">
          <v-btn
            color="primary"
            to="/tanfolyamok"
            rounded
            outlined
          >
          Tanfolyamra jelentkezés
          </v-btn>
          </v-col>
        </v-row>

    </v-container>

    <v-dialog v-model="create_contract" persistent scrollable max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Szerződés létrehozása</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="create_contract_form"
              v-model="valid"
            >
            <v-row>
              <v-col cols="12" md="6">
                    <v-text-field
                      v-model="new_contract_date"
                      label="Szerződéskötés ideje"
                      append-icon="event"
                      disabled
                      outlined
                      :rules="[rules.required]"
                    ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="category"
                  :items="category_list"
                  item-text="contract_name"
                  item-value="nkh_course_type_id"
                  label="Kategória választása"
                  outlined
                  :rules="[rules.required]"
                >
                <template v-slot:item="data">
                  <!-- HTML that describe how select should render items when the select is open -->
                  {{ data.item.contract_name }}
                  <br><br>
                </template>
              </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="gki_category"
                  :items="gki_category_list"
                  item-text="nev"
                  item-value="pallasz_id"
                  label="GKI alkategória"
                  outlined
                  :loading="loading"
                  v-if="category == 27 || category == 28 || category == 29 || category == 30 || category == 31 || category == 78 || category == 79 || category == 80"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="new_course_type"
                  :items="course_type_options"
                  label="Képzés típusa"
                  outlined
                  :rules="[rules.required]"
                  :disabled="courseTypeDisabled"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="new_contract_type"
                  :items="contract_type_options"
                  label="Szerződés típusa"
                  outlined
                  :rules="[rules.required]"
                  :disabled="gki_szerz || contractTypeDisabled"
                  item-disabled="customDisabled"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="selected_iroda"
                  :items="irodak"
                  item-value="training_place_id"
                  item-text="address"
                  label="Személyes ügyintézés helye"
                  outlined
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="red" outlined @click="create_contract = false, resetValidation()">Mégsem</v-btn>
          <v-btn color="green" outlined @click="create_contract_dialog = true" :disabled="!valid">Létrehozás</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loading_dialog" persistent max-width="400">
      <v-card>
        <v-card-text class="text-center">
          <h2 v-if="preg_preloader" class="pt-4">Rögzítés folyamatban!</h2>
          <br>
          <v-progress-circular
            :size="50"
            indeterminate
            color="red"
            v-if="preg_preloader"
          ></v-progress-circular>
          <h2 v-if="!preg_preloader">{{save_contract_response}}</h2>
          <v-row class="justify-center">
          <v-col cols="12" md="8">
          <v-btn
            v-if="contract_course_id && category != 64"
            color="primary"
            rounded
            @click="downloadContract"
          >
          Szerződés letöltése
          <v-icon right dark>cloud_download</v-icon>
          </v-btn>
          </v-col>
          <v-col cols="12" md="8">
          <v-btn
            v-if="invoice_id && !public_url"
            color="primary"
            rounded
            @click="downloadInvoice"
          >
          Díjbekérő letöltése
          <v-icon right dark>attach_money</v-icon>
          </v-btn>
          <v-btn
            class="white--text"
            v-if="invoice_id && public_url"
            color="primary"
            rounded
            :href="public_url"
            target="_blank"
          >
          Díjbekérő befizetése
          <v-icon right dark>attach_money</v-icon>
          </v-btn>
          </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="loading_dialog = false, contract_course_id = null, invoice_id = null">Bezár</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="archvie_contract_dialog" persistent max-width="300">
      <v-card>
        <v-card-text class="pt-4">Biztosan törölni szeretné a szerződést?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="archvie_contract_dialog = false">Nem</v-btn>
          <v-btn color="green" outlined @click="deleteContract(), archvie_contract_dialog = false">Igen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="create_contract_dialog" persistent max-width="400">
      <v-card>
        <v-card-title>
          <h4>Létrehozza a szerződést?</h4>
        </v-card-title>
        <v-card-text>
        <v-row>
          <v-col cols="12">
          <v-btn color="primary" rounded outlined @click="previewContract()">Szerződés Előnézet</v-btn>
          </v-col>
        </v-row>
          <v-row>

            <v-checkbox
              v-model="cont_agreement"
              label="A szerződés szövegét elfogadom!"
            >
            </v-checkbox>

          </v-row>
          <v-row v-if="new_course_type == 2 || new_course_type == 3">
                <v-col
                  cols="12"
                >
                  <v-select
                    v-model="payment_method"
                    :items="payment_methods"
                    label="Fizetési mód"
                    outlined
                    :rules="[rules.required]"
                  ></v-select>
                  <p v-if="payment_method == 2" class="red--text caption">(<b>Figyelem!</b> Átutalásos fizetési mód esetén a befizetett összeg jóváírása több napot is igénybe vehet!)</p>
                </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="create_contract_dialog = false, cont_agreement = false">Nem</v-btn>
          <v-btn color="green" outlined @click="saveContract(), create_contract_dialog = false, create_contract = false, cont_agreement = false" :disabled="!cont_agreement || !payment_method">Igen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="update_contract_dialog" persistent max-width="300">
      <v-card>
        <v-card-text class="pt-4">Biztosan módosítja a szerződést?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="update_contract_dialog = false">Nem</v-btn>
          <v-btn color="green" outlined @click="updateContract(), update_contract_dialog = false">Igen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="elearning_dialog" scrollable max-width="600">
      <v-card>
        <v-card-title
          class="h5 grey lighten-2"
          primary-title
        >
          Tanfolyam információk!
        </v-card-title>
        <v-card-text class="pt-4">
          <div class="text-justify">
          E-learning képzés választása esetén a tanfolyamot a <router-link to="/penzugy"><a>"Befizetések"</a></router-link> menüben letölthető díjbekérő összegének számlánkra érkezését követően tudja megkezdeni.
          <br><br>
          Az e-learning rendszerben (E-Titán) történő rögzítéséről a regisztrációkor megadott e-mail címére fog egy üzenetet kapni, ahol a tanfolyam elkezdésével kapcsolatban minden további információ rendelkezésére áll majd.
          <br><br>
          (<b>Figyelem!</b> A tanfolyam megkezdése az E-Titán rendszer által küldött regisztrációs e-mail megérkezésétől számított 90 napon belül lehetséges. Ezt követően csak a tandíj e-learning képzésre vonatkozó részének ismételt befizetése után kezdheti meg a tanfolyamot.)
          <br><br>
          Kérjük, hogy amennyiben a díjbekérő összegének átutalását követő két munkanapon belül nem kapja meg az e-learning rendszerben (E-Titán) történő rögzítéséről szóló regisztrációs e-mailt, úgy keresse fel bármelyik <a href='https://www.csigajogsi.hu/kapcsolat' target="_blank">ügyfélszolgálatunkat</a>, vagy küldjön nekünk <a @click="message_dialog = true">üzenetet</a>!
          <br><br>
          Az e-mailen megküldött képzési szerződést letöltheti a <router-link to="/tanfolyamok"><a>tanfolyamok</a></router-link> menüben is.
          <br><br>
          Amennyiben bármilyen kérdése felmerülne a képzéssel kapcsolatban, <a @click="message_dialog = true">munkatársaink</a> készséggel állnak rendelkezésére!
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="elearning_dialog = false">Bezár</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar :timeout="7000" v-model="save_contract_snackbar" bottom :color="!response_success ? 'error' : ''">
      {{save_contract_response}}
      <v-btn :color="!response_success ? '' : 'pink'" text @click="save_contract_snackbar = false">
        Bezár
      </v-btn>
    </v-snackbar>

</div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'

  export default {
    data () {
      return {
        new_contract_date: new Date().toISOString().substr(0, 10),
        new_driving_school: '',
        new_course_type: '',
        new_contract_type: '',
        create_contract: false,
        date_menu: false,
        username: 'Portál',
        category_list: [],
        category: '',
        rules: {
            required: value => !!value || 'Kötelező mező!',
          },
        valid: true,
        contract_date: '',
        contract_place: '',
        course_type: '',
        registry_code: '',
        contract_status: '',
        status_date: '',
        gki_szerz: false,
        courseTypeDisabled: false,
        contractTypeDisabled: false,
        course_type_options: [
          { text: 'tantermi', value: 1},
          { text: 'e-learning', value: 2},
          { text: 'tanfolyammentes', value: 3, disabled: true},
        ],
        contract_type_options: [
          { text: 'GKI szerződés', value: 4, customDisabled: true},
          { text: 'Felnőttképzési szerződés', value: 5},
        //  { text: 'Gyakorló vezetés', value: 6},
        ],
        save_contract_snackbar: false,
        save_contract_response: '',
        archvie_contract_dialog: false,
        response_success: '',
        preg_preloader: false,
        loading_dialog: false,
        invoice_id: '',
        contract_course_id: '',
        invoice_number: '',
        iv_driving_school: '',
        irodak: [],
        selected_iroda: '',
        create_contract_dialog: false,
        update_contract_dialog: false,
        elearning_dialog: false,
        cont_agreement: false,
        gki_category_contract: '',
        gki_category_list_contract: [],
        gki_category_list: [],
        gki_category: '',
        loading: false,
        payment_methods: [
          { text: 'Bankkártya (online)', value: 17 },
          { text: 'Átutalás', value: 2 },
        ],
        payment_method: 17,
      }
    },
    methods: {
      createContract() {
        this.create_contract = true
        this.new_contract_date = new Date().toISOString().substr(0, 10)
        this.new_driving_school = null
        this.new_course_type = null
        this.new_contract_type = null
        this.category = null
        this.selected_iroda = null
      },
      saveContract: async function() {
        if (this.new_course_type != 1) {
          this.preg_preloader = true
          this.loading_dialog = true
          this.invoice_id = null
          this.contract_course_id = null
        }
        this.preloader = true
        await this.gettoken()
        this.$http.post('/adatok/save_contract_20230329', {
          token: this.token,
          category_code: this.category,
          course_type: this.new_course_type,
          contract_type: this.new_contract_type,
          office_id: this.selected_iroda,
          gki_category_contract: this.gki_category,
          payment_method: this.payment_method
        }).then((response) => {
          if (response.data['success']) {
            this.googleCode()
          }
          this.preloader = false
          this.preg_preloader = false
          this.contractList()
          this.contract_id = response.data['contract_id']
          this.save_contract_response = response.data['message']
          this.response_success = response.data['success']
          this.invoice_id = response.data['invoice_id']
          this.invoice_number = response.data['iv_number']
          this.contract_course_id = response.data['course_id']
          this.iv_driving_school = response.data['school_id']
          this.contract_driving_school = response.data['school_id']
          this.public_url = response.data['public_url']
          if (this.new_course_type == 1) {
            this.save_contract_snackbar = true
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      deleteContract: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/adatok/delete_contract', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.contract_id = null
          this.preloader = false
          this.save_contract_response = response.data['message']
          this.response_success = response.data['success']
          this.contractList()
          this.save_contract_snackbar = true

        }, (error) => {
          console.log(error.data);
        })
      },
      updateContract: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/adatok/update_contract', {
          token: this.token,
          contract_id: this.contract_id,
          office_id: this.selected_iroda,
        }).then((response) => {
          this.preloader = false
          this.save_contract_response = response.data['message']
          this.response_success = response.data['success']
          this.getContractDetails()
          this.save_contract_snackbar = true
        }, (error) => {
          console.log(error.data);
        })
      },
      previewContract: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/adatok/szerzodes_preview', {
          token: this.token,
          category_code: this.category, // nkh_course_type_id
          course_type: this.new_course_type, // tanterem / e-learning
          contract_type: this.new_contract_type, // GKI / képzési, stb.
          contract_date: this.new_contract_date
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }, (error) => {
          console.log(error.data);
        })
      },
      getGKICategoryList: async function() {
        this.loading = true
        await this.gettoken()
        this.$http.post('/adatok/gki_category_list', {
          token: this.token,
          category: this.category
        }).then((response) => {
          this.loading = false
          this.gki_category_list = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      getGKICategoryListContract: async function() {
        this.loading = true
        await this.gettoken()
        this.$http.post('/adatok/gki_category_list_contract', {
          token: this.token,
          nkh_course_type_id: this.nkh_course_type_id
        }).then((response) => {
          this.loading = false
          this.gki_category_list_contract = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      getContractDetails: async function() {
        this.gki_category_contract = null
        this.preloader = true
        this.contract_status = null
        this.status_date = null
        await this.gettoken()
        this.$http.post('/adatok/contract_details', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.preloader = false
          this.contract_date = response.data[0]['contract_date']
          this.contract_place = response.data[0]['place']
          this.driving_school = response.data[0]['school_id']
          this.course_type = response.data[0]['type']
          this.contract_type = response.data[0]['template']
          this.registry_code = response.data[0]['registry_code']
          this.nkh_course_type_id = response.data[0]['course_type_key']
          this.contract_status = response.data[0]['status']
          this.status_date = response.data[0]['status_date']
          this.selected_iroda = response.data[0]['office']
          this.gki_category_contract = response.data[0]['gki_cat_key'].toString()
        }, (error) => {
          console.log(error.data);
        })
      },
      getCategoryList: async function() {
        await this.gettoken()
        this.$http.post('/adatok/category_list', {
          token: this.token
        }).then((response) => {
          this.category_list = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      contractList: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/adatok/contract_list', {
          token: this.token
        }).then((response) => {
          this.preloader = false
          this.contracts = response.data
          if (this.contracts) {
            this.contract_id = this.contracts[0]['contract_id']
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      downloadContract: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/adatok/szerzodes', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          course_id: this.contract_course_id,
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.customer_name+'_szerzodes.pdf');
          document.body.appendChild(link);
          link.click();
        }, (error) => {
          this.error_text = error.data
        })
      },
      downloadInvoice: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('tanfolyam/download_invoice', {
          token: this.token,
          school_id: this.iv_driving_school,
          invoice_id: this.invoice_id
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.invoice_number+'.pdf');
          document.body.appendChild(link);
          link.click();
        }, (error) => {
          this.error_text = error.data
        })
      },
      getOffices: async function() {
        await this.gettoken()
        this.$http.post('/adatok/csigaver_office', {
          token: this.token
        }).then((response) => {
          this.irodak = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      googleCode() {
        this.$gtag.event('conversion', {'send_to': 'AW-1049055711/HfklCJmWlG4Q36Od9AM'})
      },
      resetValidation() {
        this.$refs.create_contract_form.resetValidation()
      },
    },
    mounted() {
      if (this.contract_id) {
        this.getContractDetails()
      }
      this.getCategoryList()
      this.getOffices()
    },
    watch: {
      contract_id: function (value) {
        if (value) {
          this.getContractDetails()
        }
      },
      category: function (value) {
        this.new_contract_type = null
        this.new_course_type = null
        if (value == 27 || value == 28 || value == 29 || value == 30 || value == 31 || value == 78 || value == 79 || value == 80) {
          this.getGKICategoryList()
          this.new_contract_type = 4
          this.gki_szerz = true
        } else if (value == 2 || value == 5 || value == 6) {
          this.new_course_type = 3
          this.new_contract_type = 5
          this.courseTypeDisabled = true
          this.contractTypeDisabled = true
        } else {
          this.gki_szerz = false
          this.new_contract_type = 5
          this.courseTypeDisabled = false
          this.contractTypeDisabled = false
        }
      },
      new_contract_type: function (value) {
        if (value == 6) {
          this.new_course_type = 3
          this.courseTypeDisabled = true
        } else {
          this.courseTypeDisabled = false
        }
      },
      new_course_type: function (value) {
        if (value == 3 && this.category != 2 && this.category != 5 && this.category != 6) {
          this.new_contract_type = 6
          this.contractTypeDisabled = true
        }
      },
      contract_type: function (value) {
        if (value == 6) {
          this.course_type = 3
        }
      },
      course_type: function (value) {
        if (value == 1 || value == 2) {
          //this.contract_type = 5
        }
      },
      nkh_course_type_id() {
        this.getGKICategoryListContract()
      }
    },
    computed: {
    ...mapFields([
      'ids.customer_id',
      'ids.contract_id',
      'ids.contract_type',
      'ids.nkh_course_type_id',
      'ids.driving_school',
      'ids.contract_driving_school',
      'user_datas.contracts',
      'ids.customer_name',
      'actions.preloader',
      'actions.message_dialog',
      'user_datas.studDetailsVaild'
  ]),
  },
  }
</script>

<style lang="css">
</style>
